/**
 * Video Player — Reusable Component
 * No native controls. Play/pause button. Muted start → unmute on play.
 * Restart on end. Optional hover-to-play.
 */
(function () {
  function initPlayer(player) {
    if (player.dataset.vpInit) return;
    player.dataset.vpInit = '1';

    var video = player.querySelector('[data-vp-video]');
    var btn = player.querySelector('[data-vp-btn]');
    if (!video) return;

    var mutedStart = player.hasAttribute('data-vp-muted-start');
    var hoverPlay = player.hasAttribute('data-vp-hover');

    // Restart on end
    video.addEventListener('ended', function () {
      video.currentTime = 0;
      player.classList.remove('is-playing');
      updateButtonLabel(false);
      if (mutedStart) {
        video.muted = true;
      }
    });

    function updateButtonLabel(isPlaying) {
      if (!btn) return;
      var label = isPlaying
        ? btn.getAttribute('data-vp-label-pause')
        : btn.getAttribute('data-vp-label-play');
      if (label) {
        btn.setAttribute('aria-label', label);
      }
    }

    function play() {
      // If this player belongs to the testimonios root, pause other players in the same root
      function pauseOtherPlayersInRoot() {
        var root = player.closest('.video-testimonios-section');
        if (!root) return;
        root.querySelectorAll('[data-vp]').forEach(function (other) {
          if (other === player) return;
          var otherVideo = other.querySelector('[data-vp-video]');
          if (!otherVideo) return;
          try {
            otherVideo.pause();
          } catch (e) {
            // ignore
          }
          other.classList.remove('is-playing');
          var otherBtn = other.querySelector('[data-vp-btn]');
          if (otherBtn) {
            var playLabel = otherBtn.getAttribute('data-vp-label-play');
            if (playLabel) otherBtn.setAttribute('aria-label', playLabel);
          }
        });
      }

      pauseOtherPlayersInRoot();

      if (mutedStart) {
        video.muted = false;
      }
      var promise = video.play();
      if (promise !== undefined) {
        promise.catch(function () {
          // Autoplay blocked — try muted
          video.muted = true;
          video.play();
        });
      }
      player.classList.add('is-playing');
      updateButtonLabel(true);
    }

    function pause() {
      video.pause();
      player.classList.remove('is-playing');
      updateButtonLabel(false);
    }

    function toggle() {
      // Si ya se reproduce en silencio (autoplay), el primer toque activa el sonido en vez de pausar
      if (!video.paused && video.muted) {
        video.muted = false;
        return;
      }
      if (video.paused) {
        play();
      } else {
        pause();
      }
    }

    // Marca cuando suena en silencio para mostrar el aviso de sonido
    function syncMutedState() {
      player.classList.toggle('is-muted', video.muted && !video.paused);
    }
    video.addEventListener('volumechange', syncMutedState);
    video.addEventListener('play', syncMutedState);
    video.addEventListener('pause', syncMutedState);

    // Button click
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
      });
    }

    // Click on video area
    player.addEventListener('click', function (e) {
      if (e.target === btn || btn.contains(e.target)) return;
      toggle();
    });

    // Hover-to-play (desktop only) or IntersectionObserver (mobile)
    if (hoverPlay) {
      var isDesktop = window.matchMedia('(hover: hover)').matches;
      var hoverParent = player.closest('[data-vp-hover-parent]') || player;

      if (isDesktop) {
        hoverParent.addEventListener('mouseenter', function () {
          play();
        });

        hoverParent.addEventListener('mouseleave', function () {
          pause();
          video.currentTime = 0;
          if (mutedStart) {
            video.muted = true;
          }
        });
      } else {
        // Mobile: play when section visible, pause when not
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                hoverParent.classList.add('is-active');
                play();
              } else {
                hoverParent.classList.remove('is-active');
                pause();
                video.currentTime = 0;
                if (mutedStart) {
                  video.muted = true;
                }
              }
            });
          },
          { threshold: 0.5 }
        );
        observer.observe(hoverParent);
      }
    }
  }

  // Init all players
  function initAll() {
    document.querySelectorAll('[data-vp]').forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Editor de temas: re-inicializa players al recargar una sección
  document.addEventListener('shopify:section:load', initAll);
})();
